tpj.extend({
    scrollDav: new function () {
        var self = this;
        self.init = function () {
            //Only init if pager type is 'scroll'
            if (tpj('#current_page').length > 0) {
                tpj('#current_page').val(1);
                tpj(document).scroll(self.onScroll);
            }
        }

        self.onScroll = function (e) {
            if (self.element_in_scroll("#offers-list .offer-item:last")) {
                tpj(document).unbind('scroll');
                tpj('#loader-placeholder').html('<div class="text-center"><img src="' + ASSETS_DOMAIN + '/Content/images/spinner.gif"/></div>')

                tpj.ajax({
                    type: "POST",
                    url: Environment_APP_PATH + tpj('#pc').val() + "/" + tpj('#pa').val(),
                    data: {
                        page: parseInt(tpj('#current_page').val()) + 1,
                        records: tpj('#records_per_page').val()
                    }
                }).done(function (msg) {
                    //Update current page
                    tpj('#current_page').val(parseInt(tpj('#current_page').val()) + 1);
                    //Clean loader
                    tpj('#loader-placeholder').html("");
                    //Append data
                    tpj("#offers-list").append(msg);

                    //Initialize scripts
                    attachPopoverEvents();

                    tpj(".socialItemDetails").click(function () {
                        tpj(this).next('.shareBox').toggle();
                        tpj(this).next('.shareBox').find('.sharemetoo').lazySocialButtons();
                    });

                    ////////////////////
                    var $wlist = jQuery('.listitem2').width();
                    var $hlist = jQuery('.listitem2').height();

                    tpj('.liover').css({
                        "width": 10 + "%",
                        "height": 10 + "%",
                        "background-color": "#0099cc",
                        "position": "absolute",
                        "top": $hlist / 2 + "px",
                        "left": $wlist / 2 + "px",
                        "opacity": 0.0,
                    });
                    tpj('.fav-icon').css({
                        "top": $hlist / 2 - 11 + "px",
                        "left": $wlist + "px",
                    });
                    tpj('.book-icon').css({
                        "top": $hlist / 2 - 11 + "px",
                        "left": -25 + "px",
                    });

                    tpj(".listitem2")
                        .mouseenter(function () {
                            "use strict";
                            tpj(this).find('.liover').stop().animate({ "left": 10 + "%", "top": 10 + "%", "width": 80 + "%", "height": 80 + "%", "opacity": 0.5 });
                            tpj(this).find('.book-icon').stop().animate({ "left": $wlist / 2 - 42 + "px" });
                            tpj(this).find('.fav-icon').stop().animate({ "left": $wlist / 2 + 18 + "px" });


                        })
                        .mouseleave(function () {
                            "use strict";
                            tpj(this).find('.liover').stop().animate({ "left": $wlist / 2 + "px", "top": $hlist / 2 + "px", "width": 10 + "%", "height": 10 + "%", "opacity": 0.0 });
                            tpj(this).find('.book-icon').stop().animate({ "left": -25 + "px" });
                            tpj(this).find('.fav-icon').stop().animate({ "left": $wlist + "px" });

                        });

                    ///////////////////////

                    //Bind again
                    tpj(document).scroll(self.onScroll);

                });
            };
        }


        self.element_in_scroll = function (elem) {
            var docViewTop = tpj(window).scrollTop();
            var docViewBottom = docViewTop + tpj(window).height();

            var elemTop = tpj(elem).offset().top;
            var elemBottom = elemTop + tpj(elem).height();

            return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop)) && tpj('#current_page').val() < tpj('#total_pages').val();
        }

    }
});